var _path, _path2, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHistoryStart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 56,
    viewBox: "0 0 34 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2127 55.1999C18.2064 55.2488 18.1974 55.2958 18.1806 55.3422C17.8649 56.21 16.5327 56.2192 16.1956 55.3696C16.1702 55.3056 16.16 55.239 16.1549 55.1704C15.9819 52.8428 15.3618 47.5213 13.7206 42.9907C11.1783 35.9728 5.17417 30.0201 3.2508 27C2.83487 26.3469 3.2222 25 4.01306 25H30.3527C31.1435 25 31.1651 26.3469 30.7492 27C28.8258 30.0201 23.1235 36.0319 20.6452 42.9907C19.0216 47.5494 18.5106 52.8883 18.2127 55.1999Z",
    fill: "url(#paint0_linear_1360_2309)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 17C34 26.3888 26.3888 34 17 34C7.61116 34 0 26.3888 0 17C0 7.61116 7.61116 0 17 0C26.3888 0 34 7.61116 34 17Z",
    fill: "url(#paint1_linear_1360_2309)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1360_2309)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 15,
    fill: "#F2F2F2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1360_2309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0453 15.5481L12.6703 8.23212C11.6648 7.63798 10.125 8.21455 10.125 9.68408V24.3126C10.125 25.631 11.5559 26.4255 12.6703 25.7645L25.0453 18.452C26.1492 17.8017 26.1527 16.1985 25.0453 15.5481Z",
    fill: "#132439"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1360_2309",
    x: 2,
    y: 2,
    width: 30,
    height: 31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1360_2309"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1360_2309",
    x1: 0,
    y1: 0,
    x2: 49.685,
    y2: 30.1659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04BEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4481EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1360_2309",
    x1: 0,
    y1: 0,
    x2: 49.685,
    y2: 30.1659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04BEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4481EB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1360_2309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(9 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryStart);
export default __webpack_public_path__ + "static/media/history_start.4a23b77338a1aba583257e8b03b21e5d.svg";
export { ForwardRef as ReactComponent };